function EllipseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="5"
      height="4"
      viewBox="0 0 5 4"
      fill="none"
    >
      <circle cx="2.09998" cy="2" r="2" fill="#CBD5E1" />
    </svg>
  );
}

export default EllipseIcon;
